import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="hero"   style={{
      backgroundImage: 'url("/images/iphone-fallback.jpg")'
    }}>
      <video
        className="hero-video"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
      >
  <source src="/videos/emilia2.mp4" type="video/mp4" />
</video>

      <div className="hero-overlay"></div>
      <div className="hero-content">
{/*         <h1 className="hero-title">
          Barras de Bebidas
          <span className="highlight">Profesionales</span>
          <br />
          para tus Eventos
        </h1> */}
        <p className="hero-subtitle">
          Servicio de barras móviles premium, cócteles artesanales y atención personalizada
          para hacer de tu evento una experiencia inolvidable.
        </p>
        <div className="hero-buttons">
          <button className="btn btn-primary" onClick={scrollToContact}>
            Solicitar Cotización
          </button>
          <button 
            className="btn btn-secondary"
            onClick={() => {
              const element = document.getElementById('servicios');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Ver Servicios
          </button>
        </div>
      </div>
      <div className="hero-scroll">
        <span>Desliza para explorar</span>
        <div className="scroll-arrow"></div>
      </div>
    </section>
  );
};

export default Hero;
